import { Link } from "react-router-dom";
import { Store, HeartHandshake, Gift, LifeBuoy, ArrowRight } from "lucide-react";
import { PublicNav } from "@/components/PublicNav";

export default function About() {
  return (
    <div className="min-h-screen bg-stone-50">
      <PublicNav />
      <section className="pt-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20">
          <span className="text-xs tracking-widest uppercase text-orange-700 font-medium">Our mission</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-stone-900 mt-4 leading-tight">
            Rescue edible surplus food and essential goods.
          </h1>
          <p className="text-lg text-stone-600 mt-6 leading-relaxed">
            Gather connects grocery stores, aid organizations, charitable individuals, and people in need through one
            coordinated platform. Grocery stores rescue surplus instead of trashing it, aid organizations receive and
            distribute food and supplies, donors fund exactly what's needed, and people in need can ask for help — all in
            one connected ecosystem.
          </p>
          <div className="mt-8 p-6 rounded-2xl bg-emerald-900 text-emerald-50">
            <p className="font-heading text-xl font-medium text-white">Rescue surplus. Meet real needs. Strengthen local communities.</p>
            <p className="text-emerald-200/85 text-sm mt-2">
              Gather is a paid subscription for grocery stores only. 100% of proceeds are donated to
              Partnership to End Addiction. It's always free — no login or email — for aid organizations and individuals.
            </p>
          </div>

          <h2 className="font-heading text-2xl font-medium text-stone-900 mt-12">Four ways to take part</h2>
          <div className="grid sm:grid-cols-2 gap-4 mt-5">
            {[
              { icon: Store, t: "Grocery Stores", d: "Rescue surplus food", to: "/for-grocery-stores" },
              { icon: HeartHandshake, t: "Aid Organizations", d: "Receive & distribute", to: "/for-aid-organizations" },
              { icon: Gift, t: "Donors", d: "Fund needed items", to: "/help" },
              { icon: LifeBuoy, t: "People in Need", d: "Request help", to: "/near-me" },
            ].map((x) => (
              <Link key={x.t} to={x.to} className="flex items-center gap-4 bg-white rounded-2xl border border-stone-200 p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
                <div className="w-11 h-11 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0"><x.icon className="w-5 h-5 text-emerald-800" /></div>
                <div className="flex-1">
                  <p className="font-medium text-stone-900">{x.t}</p>
                  <p className="text-sm text-stone-500">{x.d}</p>
                </div>
                <ArrowRight className="w-4 h-4 text-stone-300" />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
